import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { soldAdsLisitingRequest } from './redux/soldAdsDispatcher';
import { imageBaseUrls } from '../../constant/ApiUrls';

function SoldAdsListingTable({ soldAdsListing, loading, totalSoldAds }) {
  const dispatch = useDispatch();

  // Local state for pagination
  const [page, setPage] = useState(0); // DataGrid page is 0-indexed
  const [pageSize, setPageSize] = useState(50);

  // Fetch data whenever page or pageSize changes
  useEffect(() => {
    dispatch(soldAdsLisitingRequest(page + 1, pageSize)); // API page is 1-indexed
  }, [dispatch, page, pageSize]);

  // Table columns
  const soldAdsColumns = [
    {
      field: 'id',
      headerName: 'NO',
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },

   {
  field: "images",
  headerName: "Image",
  width: 100,
  sortable: false,
  renderCell: (params) => {
    let imgArray = [];
    try {
      imgArray = JSON.parse(params.value); // Parse stringified JSON
    } catch (e) {
      console.error("Invalid image JSON:", params.value);
    }

    const firstImg = imgArray.length > 0 ? imgArray[0] : null;

    return firstImg ? (
      <img
        src={`${imageBaseUrls(firstImg)}`}
        alt="Ad"
        style={{ width: 60, height: 60, borderRadius: "10px", objectFit: "cover" }}
      />
    ) : (
      <span>No Image</span>
    );
  },
},
    {
      field: 'title',
      headerName: 'Title',
      width: 300,
    },
    {
      field: 'price',
      headerName: 'Price',
      width: 150,
    },


{
  field: "sold_at",
  headerName: "Sold At",
  width: 200,
  renderCell: (params) => {
    const soldAt = params.row.updated_at;

    if (!soldAt) {
      return <span>-</span>;
    }

    const date = new Date(soldAt);

    // If invalid date
    if (isNaN(date.getTime())) {
      return <span>-</span>;
    }

    const formattedDate = date.toLocaleString(); // or toLocaleDateString()

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h6>{formattedDate}</h6>
      </div>
    );
  },
},


  {
  field: "days_for_sold",
  headerName: "Days For Sold",
  width: 150,
  renderCell: (params) => {
    const createdAt = new Date(params.row.created_at);
    const updatedAt = new Date(params.row.updated_at);

    if (!createdAt || !updatedAt) {
      return <span>-</span>;
    }

    const diffMs = updatedAt - createdAt; // milliseconds difference
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h6>{diffDays} Days</h6>
      </div>
    );
  },
}




//     {
//   field: "actions",
//   headerName: "Actions",
//   width: 120,
//   sortable: false,
//   renderCell: (params) => (
//     <a
//       href={`${webSiteUrl}ads/${params.row.id}`}
//       target="_blank"
//       rel="noopener noreferrer"
//       style={{
//         textDecoration: "none",
//         color: "#1976d2",
//         fontWeight: "500",
//         border: "1px solid #1976d2",
//         borderRadius: "6px",
//         padding: "4px 8px",
//         fontSize: "12px",
//       }}
//     >
//       View
//     </a>
//   ),
// }

    // You can add more columns here
  ];

  return (
    <Paper sx={{ height: '95%', width: '100%' }}>
      <DataGrid
        rows={(soldAdsListing || []).map((item, index) => ({
          id: item.id || index,
          ...item,
        }))}
        columns={soldAdsColumns}
        pagination
        paginationMode="server"
        paginationModel={{ page, pageSize }} // ✅ Controlled pagination
        onPaginationModelChange={(model) => {
          setPage(model.page);
          setPageSize(model.pageSize);
        }}
        pageSizeOptions={[5, 10, 25, 50]} // ✅ correct prop for dropdown
        rowCount={totalSoldAds || 0}
        rowHeight={60}
        loading={loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
      />

    </Paper>
  );
}

const mapStateToProps = (state) => ({
  soldAdsListing: state.soldAdsReducer.soldAdsListing,
  loading: state.soldAdsReducer.loading,
  totalSoldAds: state.soldAdsReducer.totalSoldAds, // ✅ map total
});

export default connect(mapStateToProps)(SoldAdsListingTable);
